<script>
export default {
    methods: {
        isSet(type) {
            return Cookies.get(type);
        },
        set(type) {
            if (this.isSet(type)) {
                this.remove(type);
            } else {
                this.add(type);
            }
            window.location.reload();
        },
        remove(type) {
            Cookies.remove(type);
        },
        add(type) {
            Cookies.set(type, window.Date.now(), { expires: 365, sameSite: 'lax', secure: true });
        }
    }
};
</script>